// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GUEM","col":"styles_col__1DnNS"};